export default __webpack_public_path__ + "static/media/OmnyLogo.6cf3dc8f.png";